/** Opções do seletor de ano (métricas). Centralizado para não fixar anos no JSX. */

export function dashboardYearSelectOptions(yearsBack = 6, yearsAhead = 1): { value: string; label: string }[] {
  const current = new Date().getFullYear();
  const end = current + yearsAhead;
  const start = current - yearsBack;
  const out: { value: string; label: string }[] = [];
  for (let y = end; y >= start; y -= 1) {
    out.push({ value: String(y), label: String(y) });
  }
  return out;
}
